import { RouteRecordRaw } from 'vue-router'

// 学习进度模块路由
const learningProgressRoutes: RouteRecordRaw = {
  path: '/learning',
  name: 'LearningProgressModule',
  component: () => import('@/views/LearningProgress/index.vue'),
  meta: {
    title: '学习进度',
    icon: 'Chart',
    keepAlive: true,
    requiresAuth: true,
  },
  children: [
    // 默认重定向到学习进度总览
    {
      path: '',
      name: 'LearningProgressDefault',
      redirect: '/learning/progress',
    },
    // 学习进度详情页
    {
      path: 'progress',
      name: 'LearningProgress',
      component: () => import('@/views/LearningProgress/LearningProgress.vue'),
      meta: {
        title: '学习进度详情',
        keepAlive: true,
        requiresAuth: true,
      },
    },
    // 学习进度简洁版
    {
      path: 'brief',
      name: 'ProgressBrief',
      component: () => import('@/views/LearningProgress/Progress.vue'),
      meta: {
        title: '学习进度简览',
        keepAlive: true,
        requiresAuth: true,
      },
    },

  ],
}

export default learningProgressRoutes 